import { useMemo } from 'react'
import { useListCustomWorkflowsQuery, type CustomWorkflowSummary } from '../../../store/customWorkflow/customWorkflows'

export const WORKFLOW_LOOKUP_SIZE = 500

export const useWorkflowsById = (accountId: string): Map<string, CustomWorkflowSummary> => {
  const { currentData } = useListCustomWorkflowsQuery({ accountId, size: WORKFLOW_LOOKUP_SIZE }, { skip: !accountId })
  return useMemo(() => new Map((currentData ?? []).map((workflow) => [workflow.id, workflow])), [currentData])
}
